module.exports = __webpack_public_path__ + "static/media/popup_230418.2775c93d.jpg";